import { render, staticRenderFns } from "./annualMettingGames2023.vue?vue&type=template&id=ba9e3bf4&scoped=true&"
import script from "./annualMettingGames2023.vue?vue&type=script&lang=js&"
export * from "./annualMettingGames2023.vue?vue&type=script&lang=js&"
import style0 from "./annualMettingGames2023.vue?vue&type=style&index=0&id=ba9e3bf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9e3bf4",
  null
  
)

export default component.exports